<template>
    <div class="text-center">
        <span v-for="(item, key) in procedures">
            <el-card shadow="never" class="box-card">
                <div slot="header">
                    {{ item.name }}
                </div>
                <el-row :key="key2" v-for="(element,key2) in item.templates" :gutter="20">
                    <el-col :span="16">
                        <el-tooltip class="item" effect="dark" :content="'Ir a plantilla'" placement="top-end">
                            <el-button
                                :key="key"
                                type="text"
                                :disabled="element.isHelp"
                                size="mini"
                                @click="showEdit(element)"
                                round>
                                <p style="font-size: 8pt !important; word-break: break-all !important;">
                                    {{ element.name }}
                                </p>
                            </el-button>
                        </el-tooltip>
                    </el-col>
                    <el-col :span="4" align="center">
                            <el-tooltip class="item" effect="dark"
                                        :content="element.isActive ? 'Deshabilitar ' + element.name: 'Habilitar ' + element.name"
                                        placement="top-end">
                                    <el-button
                                        @click="changeIsActive(element.hash_id)"
                                        :type="element.isActive ? 'danger' : 'success'"
                                        plain
                                        :icon="element.isActive ? 'fas fa-trash-alt' : 'el-icon-success'"
                                        size="mini"
                                        round/>
                            </el-tooltip>
                        </el-col>
                        <el-col :span="4" align="center">
                            <el-tooltip class="item" effect="dark"
                                        content="Editar"
                                        placement="top-end">
                                <el-button
                                    @click="editTemplate(element)"
                                    type="info"
                                    plain
                                    icon="fas fa-edit"
                                    size="mini"
                                    round/>
                        </el-tooltip>
                    </el-col>

                </el-row>
            </el-card>
        </span>

        <el-dialog title="Edición"
                   :visible.sync="modalEdit"
                   :close-on-press-escape="false"
                   :close-on-click-modal="false">
            <el-form @submit.native.prevent ref="register" :model="register" label-width="120px"
                     label-position="top">
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="Categoría"
                                      prop="cat_category_id"
                                      :rules="{ required: true, message: 'Este campo es obligatorio', trigger: 'change' }">
                            <el-select v-model="register.cat_category_id"
                                       style="width: 100%"
                                       disabled
                                       placeholder="Seleccione una Categoría" filterable>
                                <el-option
                                    v-for="item in alias_this.templates"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="Trámite"
                                      prop="cat_procedure_id"
                                      :rules="{ required: true, message: 'Este campo es obligatorio', trigger: 'change' }">
                            <el-select v-model="register.cat_procedure_id" style="width: 100%"
                                       placeholder="Seleccione un Trámite" filterable>
                                <el-option
                                    v-for="item in alias_this.procedures.filter(up => up.cat_category_id == register.cat_category_id) "
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="Nombre de la Plantilla"
                                      prop="name"
                                      :rules="[{ required: true, message: 'Este campo es obligatorio', trigger: 'change' },
                                      { max: 70, message: 'Este campo debería ser de máximo 70 caracteres', trigger: 'blur' },
                                    {pattern:/^[ña-zÀ-úÑA-Z0-9 _]+?$/,message: 'Ingrese sólo letras y/o números'}]">
                            <el-input v-my-only-alphanumeric="{maxChars: 70}" :maxlength="70" v-model="register.name"/>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item
                            label="¿Esta plantilla es una hoja de ayuda?">
                            <el-switch
                                @change="searchHelp(register)"
                                v-model="register.isHelp"
                                :disabled="register.first"
                                active-text="Sí"
                                inactive-color="#13322B"
                                active-color="#9d2438"
                                inactive-text="No">
                            </el-switch>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row v-if="register.isHelp">
                    <el-col :span="12">
                        <el-form-item label="Monto a pagar en MXN"
                                      prop="name"
                                      :rules="{ required: true, message: 'Este campo es obligatorio', trigger: 'change' }">
                            <vue-numeric currency="$"
                                         class="el-input__inner"
                                         separator=","
                                         v-model="register.amount"
                                         :precision="2"
                            ></vue-numeric>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-col :span="12">
                        <el-form-item
                            label="¿Esta plantilla es un oficio?">
                            <el-switch
                                v-model="register.isPaper"
                                active-text="Sí"
                                inactive-color="#13322B"
                                active-color="#9d2438"
                                inactive-text="No">
                            </el-switch>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item
                            label="Certificación con QR">
                            <el-switch
                                v-model="register.isQr"
                                active-text="Sí"
                                inactive-color="#13322B"
                                active-color="#9d2438"
                                inactive-text="No">
                            </el-switch>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12" v-if="register.cat_category_id == 1 && register.isPaper">
                        <el-form-item label="Oficios Adquisiciones"
                                      prop="cat_trade_id"
                                      :rules="{ required: true, message: 'Este campo es obligatorio', trigger: 'change' }">
                            <el-select v-model="register.cat_trade_id" style="width: 100%"
                                       placeholder="Seleccione un Oficio" filterable>
                                <el-option
                                    v-for="item in trades"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" v-if="register.cat_category_id == 2 && register.isPaper">
                        <el-form-item label="Oficios Fideicomisos"
                                      prop="cat_trade_trust_id"
                                      :rules="{ required: true, message: 'Este campo es obligatorio', trigger: 'change' }">
                            <el-select v-model="register.cat_trade_trust_id" style="width: 100%"
                                       placeholder="Seleccione un Oficio" filterable>
                                <el-option
                                    v-for="item in tradesTrust"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item
                            label="Acuse de registro"
                            prop="first"
                            :rules="{ required: true, message: 'Este campo es obligatorio', trigger: 'change' }">
                            <el-switch
                                @change="disabledSwitch(register)"
                                v-model="register.first"
                                :disabled="register.isHelp"
                                active-text="Sí"
                                inactive-color="#13322B"
                                active-color="#9d2438"
                                inactive-text="No">
                            </el-switch>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item
                            label="Requiere Firma electrónica">
                            <el-switch
                                v-model="register.isSigned"
                                active-text="Sí"
                                inactive-color="#13322B"
                                active-color="#9d2438"
                                inactive-text="No">
                            </el-switch>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
                        <el-button
                            type="danger"
                            icon="fas fa-times"
                            @click="modalEdit=false">
                            Cancelar
                        </el-button>
                        <el-button
                            type="primary"
                            icon="fas fa-save"
                            @click="updateTemplate()">
                            Guardar Plantilla
                        </el-button>
                    </span>
        </el-dialog>

    </div>
</template>

<script>
import {mapState, mapGetters, mapActions, mapMutations} from 'vuex';

export default {
    props: {
        procedures: {
            type: Array
        },
        isProcedure: {
            type: Boolean
        },
        isTemplate: {
            type: Boolean
        },
        isAction: {
            type: Boolean
        },
        trades: {},
        tradesTrust: {},
        alias_this: {}
    },

    computed: {
        ...mapGetters('templates', {
            templateForm: "templateForm",
        }),
    },
    data() {
        return {
            modalEdit: false,
            register: {},
            aliasHash: null,
        }
    },

    methods: {

        editTemplate(element) {
            this.register = Object.assign({}, element);
            this.modalEdit = true
        },

        disabledSwitch(register) {
            if (register.first) {
                //register.isSigned = false;
                register.isHelp = false
            }

        },

        searchHelp(element) {
            if (element.cat_procedure_id && element.cat_category_id) {
                element.isHelp ? element.first = false : null;
                element.isHelp ? element.isSigned = false : null;
                axios.get('/api/search-help', {params: element}).then(response => {
                    if (!response.data.success) {
                        element.isHelp = false;
                        this.$store.dispatch('notifications/warning', {msg: response.data.message}, {root: true});
                    }
                })
            } else {
                element.isHelp = false
                this.$store.dispatch('notifications/warning', {msg: 'Primero seleccione una Categoría y un Tipo de trámite.'}, {root: true});
            }
        },

        showEdit(papers) {
            let cat_template_id = papers.id;
            axios.post('/api/papers/search-config', {cat_template_id: cat_template_id}).then(response => {
                let id = response.data.config;
                this.templateForm.hash_id = id;
                this.templateForm.cat_procedure_id = papers.cat_procedure_id;
                this.$router.push('/administracion/plantillas/configuracion')
            }).catch(() => {
                this.$notify({
                    title: 'Error',
                    message: 'Algo salió mal, trata nuevamente',
                });
            });
        },

        changeIsActive(hash) {
            if (hash) {
                axios.post(`/api/templates/activate-or-deactivate/${hash}`,
                    {params: {hash: hash}, deactivate: true}).then(response => {
                    if (response.data.success) {
                        this.$store.dispatch('notifications/ok', {msg: response.data.message}, {root: true});
                        this.alias_this.getAgreements();
                    } else {
                        this.$store.dispatch('notifications/error', {msg: response.data.message}, {root: true});
                    }
                }).catch(_ => {
                    console.log('changeIsActive', _);
                    this.$store.dispatch('notifications/error', {msg: 'No se pudo completar la solicitud'}, {root: true});
                });
            }

        },

        updateTemplate() {
            axios.post(`/api/templates/activate-or-deactivate/${this.register.hash_id}`,
                {params: {hash: this.register.hash_id, register: this.register}}).then(response => {
                if (response.data.success) {
                    this.$store.dispatch('notifications/ok', {msg: response.data.message}, {root: true});
                    this.alias_this.getAgreements();
                } else {
                    this.$store.dispatch('notifications/error', {msg: response.data.message}, {root: true});
                }
            }).catch(_ => {
                console.log('changeIsActive', _);
                this.$store.dispatch('notifications/error', {msg: 'No se pudo completar la solicitud'}, {root: true});
            });
        }

    }

}
</script>

<style scoped>

</style>
